<template>
  <div class="transfer-child-wrap">
    <div class="transfer-child-head">
      <span>{{
        `${
          tableSelectedKeys.length > 0 ? tableSelectedKeys.length + "/" : ""
        }${filteredItems.length || "0"} 项`
      }}</span>
      <span>{{ transferDirection == "left" ? "点位" : "已选点位" }}</span>
    </div>
    <a-input-search
      class="transfer-table-input"
      placeholder="请输入搜索内容"
      @change="onSearch"
    />
    <a-table
      rowKey="id"
      size="small"
      style="width: 374px;"
      :bordered="false"
      :columns="tableColumns"
      :data-source="filteredItems"
      :loading="tableLoading || waiting"
      :pagination="{ showLessItems: true, onChange: changePage }"
      :row-selection="{
        fixed: true,
        columnWidth: 40,
        selectedRowKeys: currentSelectedRowKeys,
        onChange: onSelectChange,
        hideDefaultSelections: true,
        onSelect(record, selected) {
          record.checked = selected;
          updateTableSelectedKeys();
          updateCurrentPageSelectedRowKeys(currentPage);
        },
        onSelectAll(selected) {
          filteredItems.forEach(item => {
            item.checked = selected;
          });
          updateTableSelectedKeys();
          updateCurrentPageSelectedRowKeys(currentPage);
        }
      }"
    >
    </a-table>
  </div>
</template>

<script>
export default {
  props: {
    transferDirection: {
      type: String,
      required: true
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    tableLoading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      waiting: false,
      searchTimeOut: null,
      searchText: "",
      tableSelectedKeys: [],
      currentSelectedRowKeys: [],
      currentPage: 1,
      tableColumns: [
        {
          title: "Mac",
          key: "devId",
          dataIndex: "devId",
          width: 160,
          ellipsis: true,
          customRender: text => text || "--"
        },
        {
          title: "点位名称",
          key: "deviceName",
          dataIndex: "deviceName",
          width: 160,
          ellipsis: true,
          customRender: text => text || "--"
        }
      ]
    };
  },
  computed: {
    filteredItems() {
      return this.dataSource.filter(
        item =>
          `${item.devId || ""}${item.deviceName || ""}`.indexOf(
            this.searchText
          ) !== -1
      );
    },
    filteredItemsLength() {
      return this.filteredItems.length;
    }
  },
  watch: {
    // 移动时，清空勾选
    filteredItemsLength() {
      this.updateTableSelectedKeys();
      this.updateCurrentPageSelectedRowKeys(this.currentPage);
    },
    // 页数改变时触发
    currentPage(val) {
      this.updateCurrentPageSelectedRowKeys(val);
    }
  },
  methods: {
    // 更新表格所选项
    updateTableSelectedKeys() {
      let tableLength = this.dataSource.length;
      let tempSelectedRowKeys = [];
      for (let i = tableLength - 1; i >= 0; i--) {
        if (this.dataSource[i].checked) {
          tempSelectedRowKeys.push(this.dataSource[i].id);
        }
      }
      this.tableSelectedKeys = tempSelectedRowKeys;
      this.$emit("selectedKeys", tempSelectedRowKeys);
    },
    // 更新当前页面所选项
    updateCurrentPageSelectedRowKeys(page) {
      if (!(page > 0)) return;
      let tempPageList = this.filteredItems.slice((page - 1) * 10, page * 10);
      this.currentSelectedRowKeys = tempPageList
        .filter(item => item.checked)
        .map(item => item.id);
    },
    // 切换表格分页
    changePage(page) {
      this.currentPage = page;
    },
    onSelectChange() {},
    // 表格搜索
    onSearch(e) {
      clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        this.searchText = e.target._value;
      }, 150);
    }
  }
};
</script>

<style scoped lang="scss">
.transfer-child-wrap {
  .transfer-child-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px 8px 12px;
    border-bottom: 1px solid #e8e8e8;
    margin: 0 -12px 16px;
  }
  min-height: 573px;
  padding: 8px 12px 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  .transfer-table-input {
    width: 100%;
    margin-bottom: 12px;
    /deep/ .ant-input {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }
  /deep/ .ant-table-small {
    border-radius: 0;
    border: none;
  }
  /deep/ .ant-table-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 380px;
    border-bottom: none;
  }
}
</style>
